import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';

import { Container } from './styles';

export default function RespostaEdit({ match }) {
  const selectRef = useRef(null);
  const [dadoResposta, setDadoResposta] = useState('');
  const [carregar, setCarregar] = useState(false);

  useEffect(() => {
    async function getDados() {
      const { id, idQuizzes } = match.params;
      const response = await api.get(
        `pergunta/${idQuizzes}/alternativas/${id}`
      );
      setDadoResposta(response.data.resposta);
    }
    getDados();
  }, [match.params]);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      const { idProduct, idQuizzes, id } = match.params;
      selectRef.current.setErrors({});
      const schema = Yup.object().shape({
        resposta: Yup.string().required('Preencha o campo resposta'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`pergunta/${idQuizzes}/alternativas/${id}`, {
        resposta: data.resposta,
      });

      toast.success('Resposta editado com sucesso');
      history.push(`/questionario-edit/${idProduct}/quizzes/${idQuizzes}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        selectRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar resposta verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Editando Respostas</h4>
      <Card>
        <Form
          ref={selectRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
          initialData={{ resposta: dadoResposta }}
        >
          <Input icon="MdPerson" name="resposta" label="Resposta" type="text" />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

RespostaEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idProduct: PropTypes.string,
      idQuizzes: PropTypes.string,
      id: PropTypes.string,
    }),
  }).isRequired,
};
